import React from 'react';
import '../../styles/roboticsProduct.css'
import AnimatedArrowButton from '../AnimatedArrowButton';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import product1 from '../../assets/h16.png';
import product2 from '../../assets/h2.png';
import product3 from '../../assets/h15.png';
import product4 from '../../assets/h14.png';
import bgimage from '../../assets/half-circle.png';

const HorecaProducts3= () => {

    const sliderSettings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows:false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      };

      const cards = [
        { name: 'Whole Milk (Organic)', company: "Creamy and fresh, sourced from grass-fed cows." , image:product1  },
        { name: 'Artisanal Multigrain Bread', company: "Nutty and wholesome, baked fresh daily." , image:product2  },
        { name: 'Cheddar Cheese (Aged)', company: "Rich and sharp flavor, perfect for sandwiches or platters." , image:product3 },
        { name: 'Butter Croissants', company: "Flaky and buttery, a breakfast favorite." , image:product4 }, 
        
      ];

    return(<div  className='roboticsproduct mt-5 pb-5 ' style={{height:'auto'}}>

        
            <div className='roboticsproduct-inner pt-4' >
            
            
            
            <div className='myservices' style={{display:'flex',padding:'25px',gap:'10px',paddingTop:"2rem", width:'100%',paddingBottom:'1rem'}}>
                        
                        <div className='services-msg' style={{textAlign:'left', width:'100%'}}>
                            <div style={{display:'flex' , alignItems:'start', justifyContent:'space-between', width:'100%'}}><h1 style={{fontWeight:"600"}}>Dairy & Bakery</h1> <div className='button1'></div> </div>
                            <p style={{color:'white', fontSize:"14px"}}>From artisanal breads to creamy dairy products, find everything you need.</p>
                            <div className='button2'> </div> 
                        </div>
            </div>
            <hr></hr>
            <div style={{  maxWidth: "90%", margin: "auto" }}  className='mt-5'>
      <Slider {...sliderSettings}>
        {cards.map((card) => (
          <div key={card.id} style={{ padding: "10px"}}>
            <div
              style={{
                
                backgroundColor: "#0C0A00",
                border:'1px solid #383838',
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                borderRadius: "10px",
                marginLeft:"10px",
                marginRight:"10px",
                overflow:'hidden',
                
                flexDirection:'column',
                textAlign:'left'
              }}
              className='product-card'
            >
              <div style={{height:'150px',width:'100%', overflow:'hidden'}}>
                <img src={card.image} style={{objectFit:'cover',width:'100%', height:'100%'}}></img>
              </div>
              <div style={{padding:'1rem' ,height:'150px'}}>
              <h5 style={{width:'100%',marginTop:'1rem'}}>{card.name}</h5>
            <p style={{width:'100%', fontSize:'0.7rem', color:'white',paddingBottom:'0.9rem',marginBottom:'0.3rem'}}>{card.company}</p>
            </div>
            </div>
            
          </div>
        ))}
      </Slider>
    </div>
            

            </div>
        
    

    </div>);

}

export default HorecaProducts3;